import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["merchantIdField", "customFields", "accountSourceKind"];
  static classes = ["show", "hide"];

  connect() {
    this.toggle();
  }

  toggle() {
    const selectedValue = this.accountSourceKindTarget.value;
    this.updateVisibility(this.customFieldsTarget, selectedValue === "custom");
    this.updateVisibility(this.merchantIdFieldTarget, selectedValue === "mammoth");
  }

  updateVisibility(element, isVisible) {
    element.classList.toggle(this.showClass, isVisible);
    element.classList.toggle(this.hideClass, !isVisible);
  }
}
